import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _VIDEO_SOURCE_REGEX_M;
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _pick from 'lodash/pick';
import { EMBED_SOURCE_DEFAULT_TYPE, EMBED_SOURCE_VIMEO_TYPE, EMBED_SOURCE_YOUTUBE_TYPE } from '../../../foundation/components/Embed/Embed.constants';
var YOUTUBE_REGEX = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:embed\/|watch\?v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
var VIMEO_REGEX = /^(?:https?:\/\/)?(?:www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/;
var allowedParams = {
  youtube: ['mute', 'loop', 'autoplay', 'controls'],
  vimeo: ['controls', 'muted', 'autoplay', 'background']
};
var parameterMappings = {
  vimeo: {
    muted: 'mute'
  }
};
var VIDEO_SOURCE_REGEX_MAP = (_VIDEO_SOURCE_REGEX_M = {}, _defineProperty(_VIDEO_SOURCE_REGEX_M, EMBED_SOURCE_YOUTUBE_TYPE, YOUTUBE_REGEX), _defineProperty(_VIDEO_SOURCE_REGEX_M, EMBED_SOURCE_VIMEO_TYPE, VIMEO_REGEX), _VIDEO_SOURCE_REGEX_M);
function extractVideoId(url, pattern) {
  var match = url.match(pattern);
  return match ? match[1] : null;
}
function getSourceFromUrl(url) {
  if (YOUTUBE_REGEX.test(url)) {
    return EMBED_SOURCE_YOUTUBE_TYPE;
  }
  if (VIMEO_REGEX.test(url)) {
    return EMBED_SOURCE_VIMEO_TYPE;
  }
  return EMBED_SOURCE_DEFAULT_TYPE;
}
export function resolveVideoSource(_ref) {
  var url = _ref.url,
    source = _ref.source,
    videoId = _ref.videoId;
  if (source && videoId) {
    return {
      source: source,
      videoId: videoId
    };
  }
  var urlSource = getSourceFromUrl(url);
  var resolvedVideoId = VIDEO_SOURCE_REGEX_MAP[urlSource] ? extractVideoId(url, VIDEO_SOURCE_REGEX_MAP[urlSource]) : null;
  return {
    source: urlSource,
    videoId: resolvedVideoId
  };
}
export function parseUrlProps(source, _ref2) {
  var url = _ref2.url;
  if (!url) {
    return {};
  }
  var queryParams = Object.fromEntries(new URLSearchParams(new URL(url).search));
  var whitelist = allowedParams[source] || [];
  var mappings = parameterMappings[source] || {};
  var parsedParams = _pick(queryParams, whitelist);
  var result = Object.fromEntries(Object.entries(parsedParams).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    var mappedKey = mappings[key] || key;
    return [mappedKey, value === '1' || value === 'true'];
  }));

  // Special handling for Vimeo background parameter
  var background = result.background;
  if (source === EMBED_SOURCE_VIMEO_TYPE && background === true) {
    result.controls = false;
  }
  return result;
}
export function getVideoPlayerProps(props) {
  if (!props) {
    return null;
  }
  var _resolveVideoSource = resolveVideoSource(props),
    resolvedSource = _resolveVideoSource.source,
    videoId = _resolveVideoSource.videoId;
  var source = resolvedSource || EMBED_SOURCE_DEFAULT_TYPE;
  var parsedProps = parseUrlProps(source, props);
  return _objectSpread(_objectSpread(_objectSpread({}, props), parsedProps), {}, {
    videoId: videoId,
    source: source
  });
}
export function getPlayerComponent(source, playerComponents) {
  var defaultPlayerComponent = playerComponents["default"];
  return playerComponents[source] || defaultPlayerComponent;
}